// 取得 WebSocket 基礎地址：生產環境走同源（HTTPS 頁面自動使用 wss），開發環境使用 .env 配置
export function getSocketBase() {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_SOCKET
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${protocol}//${window.location.host}/`
}

export function getSocketUrl(suffix = '') {
  return `${getSocketBase()}websocket${suffix}`
}
